import { BehaviorSubject } from "rxjs";

import config from "../../config/index";
import requestOptions from "@/helpers/RequestOptions";
import handleResponse from "@/helpers/HandleResponses";
import handleBlobResponse from "@/helpers/HandleBlobResponses";

export const organizationService = {
  addOrganization,
  updateOrganization,
  getOrganization,
  registerAsAdmin,
  getLeaveTypes,
  addLeaveType,
  getLeaveSettings,
  initiateLeaveSettings,
  updateLeaveSettings,
  removeLeaveType,
  addPolicy,
  addDepartmentPolicy,
  updateDepartmentPolicy,
  removeDepartmentPolicy,
  getDepartmentPolicies,

  addCompanyUnit,
  getCompanyUnits,
  updateCompanyUnit,
  removeCompanyUnit,

  addDepartmentUnit,
  getDepartmentUnits,
  updateDepartmentUnit,
  removeDepartmentUnit,

  addDesignationRole,
  getDesignationRoles,
  updateDesignationRole,
  removeDesignationRole,

  addCompany,
  addAccountSetting,
  getCompanies,
  getCompany,
  checkUser,
  getPolicyDocument,
  getAccountSetting,
  addRank,
  getRanks,
  updateCompany,
  updateAccountSetting,
  removeCompany,
  registerAsHR,
  addDepartment,
  getDepartments,
  addDesignation,
  getDesignations,
  updateDesignation,
  removeDesignation,
  updateDepartment,
  removeDepartment,
  removeRank,
  getBanks,
  getPensions,
  getStates,
  updateRank,
  postHoliday,
  putHoliday,
  removeHoliday,
  getHolidays,
  getRoles,
  downloadDepartmentTemplate,
  downloadUnitTemplate,
  downloadDesignationTemplate,
  downloadRankTemplate,
  importDepartment,
  importDepartmentUnit,
  importDesignation,
  importRank,
  updateDepartmentByGMD,
  updateDesignationByGMD,
  updateCompanyUnitsByGMD,
  addCarLoanSetting,
  updateCarLoanSetting,
  downloadCarLoanSettingTemplate,
  importCarLoanSetting,
  removeCarLoanSetting,
  getCarLoanSettings
};

function addOrganization(
  name,
  rcnumber,
  address,
  contact,
  contactnumber,
  contactemail,
  contactaddress,
  file,
  theme
) {
  let formData = new FormData();
  formData.append("Name", name);
  formData.append("ContactPerson", contact);
  formData.append("Phone", contactnumber);
  formData.append("Email", contactemail);
  formData.append("Address", address);
  formData.append("ContactAddress", contactaddress);
  formData.append("RegistrationNumber", rcnumber);
  formData.append("Theme", theme);
  formData.append("UploadFile", file);
  return fetch(
    `${config.apiurl}/organization`,
    requestOptions.postForm(formData)
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}

function updateOrganization(
  id,
  name,
  rcnumber,
  address,
  contact,
  contactnumber,
  contactemail,
  contactaddress,
  file,
  theme
) {
  let formData = new FormData();
  formData.append("Name", name);
  formData.append("ContactPerson", contact);
  formData.append("Phone", contactnumber);
  formData.append("Email", contactemail);
  formData.append("Address", address);
  formData.append("ContactAddress", contactaddress);
  formData.append("RegistrationNumber", rcnumber);
  formData.append("Theme", theme);
  formData.append("UploadFile", file);
  return fetch(
    `${config.apiurl}/organization/${id}`,
    requestOptions.putForm(formData)
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}

function addAccountSetting(
  companyId,
  bankAccountForSalary,
  bankCodeForSalary,
  bankAccountForPension,
  bankCodeForPension,
  bankAccountForTax,
  bankCodeForTax,
  employerCodeForPension,
  remitaUserAccount,
  remitaSecret,
  salaryPayDay,
  welcomeGuideTemplate,
  profileNOK,
  profileGLI,
  automateTaxPension,
  mgtDesignationId
) {
  var req = {
    companyId: companyId,
    bankAccountForSalary,
    bankCodeForSalary,
    bankAccountForPension,
    bankCodeForPension,
    bankAccountForTax,
    bankCodeForTax,
    employerCodeForPension,
    remitaUserAccount,
    remitaSecret,
    salaryPayDay,
    welcomeGuideTemplate,
    profileNOK,
    profileGLI,
    automateTaxPension,
    mgtDesignationId
  };
  return fetch(`${config.apiurl}/company/PostAccount`, requestOptions.post(req))
    .then(handleResponse)
    .then(id => {
      return id;
    });
}

function addRank(
  rank,
  readHoliday,
  readLeave,
  readAssets,
  readTimesheet,
  writeHoliday,
  writeLeave,
  writeAssets,
  writeTimesheet,
  deleteHolidays,
  deleteLeave,
  deleteAssets,
  deleteTimesheet
) {
  var req = {
    rankName: rank,
    rankPermission: {
      readHoliday,
      readLeave,
      readAssets,
      readTimesheet,
      writeHoliday,
      writeLeave,
      writeAssets,
      writeTimesheet,
      deleteHolidays,
      deleteLeave,
      deleteAssets,
      deleteTimesheet
    }
  };
  return fetch(
    `${config.apiurl}/Organization/addrank`,
    requestOptions.post(req)
  ).then(handleResponse);
}

function getRanks() {
  return fetch(`${config.apiurl}/Organization/ranks`, requestOptions.get())
    .then(handleResponse)
    .then(model => {
      return model;
    });
}
function addCarLoanSetting(
  companyId,
  rank,
  amount
) {
  var req = {
    companyId: companyId,
    rankId: rank,
    amount: amount
  };
  return fetch(
    `${config.apiurl}/Organization/addCarLoanSetting`,
    requestOptions.post(req)
  ).then(handleResponse);
}
function getCarLoanSettings() {
  return fetch(`${config.apiurl}/Organization/CarLoanSettings`, requestOptions.get())
    .then(handleResponse)
    .then(model => {
      return model;
    });
}

function updateCarLoanSetting(req) {
  return fetch(
    `${config.apiurl}/Organization/updateCarLoanSetting/${req.id}`,
    requestOptions.put(req)
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}

function removeCarLoanSetting(id) {
  return fetch(
    `${config.apiurl}/Organization/DeleteCarLoanSetting?id=${id}`,
    requestOptions.delete()
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}

function checkUser(email) {
  return fetch(
    `${config.apiurl}/Account/checkuser?email=${email}`,
    requestOptions.get()
  )
    .then(handleResponse)
    .then(model => {
      return model;
    });
}

function updateRank(
  id,
  rank,
  readHoliday,
  readLeave,
  readAssets,
  readTimesheet,
  writeHoliday,
  writeLeave,
  writeAssets,
  writeTimesheet,
  deleteHolidays,
  deleteLeave,
  deleteAssets,
  deleteTimesheet,
  permissionid
) {
  var req = {
    id,
    rankName: rank,
    rankPermission: {
      id: permissionid,
      RankId: id,
      readHoliday,
      readLeave,
      readAssets,
      readTimesheet,
      writeHoliday,
      writeLeave,
      writeAssets,
      writeTimesheet,
      deleteHolidays,
      deleteLeave,
      deleteAssets,
      deleteTimesheet
    }
  };
  return fetch(
    `${config.apiurl}/Organization/updaterank/${id}`,
    requestOptions.put(req)
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}

function removeRank(id) {
  return fetch(
    `${config.apiurl}/Organization/DeleteRank?id=${id}`,
    requestOptions.delete()
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}

function postHoliday(title, holidayDate) {
  var req = {
    title,
    holiday: holidayDate
  };
  return fetch(
    `${config.apiurl}/Miscellaneous/createholiday`,
    requestOptions.post(req)
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}

function putHoliday(req) {
  return fetch(
    `${config.apiurl}/Miscellaneous/updateHoliday`,
    requestOptions.put(req)
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}

function getHolidays() {
  return fetch(
    `${config.apiurl}/Miscellaneous/getHolidays`,
    requestOptions.get()
  )
    .then(handleResponse)
    .then(model => {
      return model;
    });
}
function removeHoliday(id) {
  return fetch(
    `${config.apiurl}/Miscellaneous/DeleteHoliday?id=${id}`,
    requestOptions.delete()
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}
function registerAsAdmin(
  orgId,
  contact,
  contactnumber,
  contactemail,
  password,
  confirmPassword
) {
  var req = {
    organizationId: orgId,
    fullName: contact,
    phoneNumber: contactnumber,
    email: contactemail,
    password: password,
    confirmPassword: confirmPassword
  };
  return fetch(
    `${config.apiurl}/account/registerasadmin`,
    requestOptions.post(req)
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}

function registerAsHR(
  companyId,
  firstName,
  lastName,
  address,
  gender,
  phone,
  email,
  employeeCode
) {
  var req = {
    companyId: companyId,
    firstName,
    lastName,
    phone,
    email,
    address,
    gender,
    employeeCode
  };
  return fetch(`${config.apiurl}/employee/postHR`, requestOptions.post(req))
    .then(handleResponse)
    .then(id => {
      return id;
    });
}

function addLeaveType(name) {
  var req = {
    name: name
  };
  return fetch(
    `${config.apiurl}/Organization/addleavetype`,
    requestOptions.post(req)
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}

function addPolicy(policy) {
  return fetch(
    `${config.apiurl}/Company/PostLeavePolicy`,
    requestOptions.post(policy)
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}

function initiateLeaveSettings(id) {
  return fetch(
    `${config.apiurl}/Company/initiateLeaveSetting?id=${id}`,
    requestOptions.post(null)
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}

function getOrganization() {
  return fetch(`${config.apiurl}/Organization`, requestOptions.get())
    .then(handleResponse)
    .then(model => {
      return model;
    });
}

function getLeaveTypes() {
  return fetch(`${config.apiurl}/Organization/leavetypes`, requestOptions.get())
    .then(handleResponse)
    .then(model => {
      return model;
    });
}

function getAccountSetting(id) {
  return fetch(
    `${config.apiurl}/company/GetAccount?id=${id}`,
    requestOptions.get()
  )
    .then(handleResponse)
    .then(model => {
      return model;
    });
}

function getLeaveSettings(id) {
  return fetch(
    `${config.apiurl}/company/GetLeaveSettings?id=${id}`,
    requestOptions.get()
  )
    .then(handleResponse)
    .then(model => {
      return model;
    });
}

function removeLeaveType(id) {
  return fetch(
    `${config.apiurl}/Organization/DeleteLeaveType?id=${id}`,
    requestOptions.delete()
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}

function removeLeaveType(id) {
  return fetch(
    `${config.apiurl}/Organization/DeleteLeaveType?id=${id}`,
    requestOptions.delete()
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}

function addCompany(name, abbrv, address, contactPerson, phone, email) {
  var req = {
    name,
    abbrv,
    address,
    contactPerson,
    phone,
    email
  };
  return fetch(`${config.apiurl}/company`, requestOptions.post(req))
    .then(handleResponse)
    .then(id => {
      return id;
    });
}

function addDesignation(name, department) {
  var req = {
    name,
    departmentId: department
  };
  // console.log(req)
  return fetch(
    `${config.apiurl}/Miscellaneous/createDesignation`,
    requestOptions.post(req)
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}

function getPolicyDocument(path) {
  var req = {
    path
  };
  // console.log(req)
  return fetch(
    `${config.apiurl}/Miscellaneous/downloadFile`,
    requestOptions.post(req)
  )
    .then(handleBlobResponse)
    .then(blob => {
      return blob;
    });
}

function getDesignations() {
  return fetch(
    `${config.apiurl}/Miscellaneous/getDesignations`,
    requestOptions.get()
  )
    .then(handleResponse)
    .then(model => {
      return model;
    });
}

function addDepartmentPolicy(name, description, departmentId, cv, companyId) {
  let formData = new FormData();
  formData.append("Name", name);
  formData.append("Description", description);
  formData.append("DepartmentId", departmentId);
  formData.append("Uploadfile", cv);
  return fetch(
    `${config.apiurl}/Miscellaneous/createPolicy/${companyId}`,
    requestOptions.postForm(formData)
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}

function getDepartmentPolicies() {
  return fetch(
    `${config.apiurl}/Miscellaneous/getPolicies`,
    requestOptions.get()
  )
    .then(handleResponse)
    .then(model => {
      return model;
    });
}

function updateDepartmentPolicy(
  id,
  name,
  description,
  departmentId,
  cv,
  companyId
) {
  let formData = new FormData();
  formData.append("Id", id);
  formData.append("Name", name);
  formData.append("Description", description);
  formData.append("DepartmentId", departmentId);
  formData.append("Uploadfile", cv);
  return fetch(
    `${config.apiurl}/Miscellaneous/updatePolicy/${companyId}`,
    requestOptions.putForm(formData)
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}

function getBanks() {
  return fetch(
    `${config.apiurl}/Miscellaneous/getLookup?type=Banks`,
    requestOptions.get()
  )
    .then(handleResponse)
    .then(model => {
      return model;
    });
}
function getStates() {
  return fetch(
    `${config.apiurl}/Miscellaneous/getLookup?type=STATES`,
    requestOptions.get()
  )
    .then(handleResponse)
    .then(model => {
      return model;
    });
}
function downloadDepartmentTemplate() {
  return fetch(
    `${config.apiurl}/Organization/DownloadDepartmentTemplate`,
    requestOptions.get()
  )
    .then(handleBlobResponse)
    .then(blob => {
      return blob;
    });
}
function downloadUnitTemplate() {
  return fetch(
    `${config.apiurl}/Organization/DownloadDepartmentUnitTemplate`,
    requestOptions.get()
  )
    .then(handleBlobResponse)
    .then(blob => {
      return blob;
    });
}
function downloadDesignationTemplate() {
  return fetch(
    `${config.apiurl}/Organization/DownloadDesignationTemplate`,
    requestOptions.get()
  )
    .then(handleBlobResponse)
    .then(blob => {
      return blob;
    });
}
function downloadRankTemplate() {
  return fetch(
    `${config.apiurl}/Organization/DownloadRankTemplate`,
    requestOptions.get()
  )
    .then(handleBlobResponse)
    .then(blob => {
      return blob;
    });
}
function downloadCarLoanSettingTemplate() {
  return fetch(
    `${config.apiurl}/Organization/DownloadCarLoanSettingTemplate`,
    requestOptions.get()
  )
    .then(handleBlobResponse)
    .then(blob => {
      return blob;
    });
}
function importDepartment(file) {
  let formData = new FormData();
  formData.append("File", file);
  return fetch(
    `${config.apiurl}/organization/importDepartment`,
    requestOptions.postForm(formData)
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}
function importDesignation(file) {
  let formData = new FormData();
  formData.append("File", file);
  return fetch(
    `${config.apiurl}/organization/importDesignation`,
    requestOptions.postForm(formData)
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}
function importRank(file) {
  let formData = new FormData();
  formData.append("File", file);
  return fetch(
    `${config.apiurl}/organization/importRank`,
    requestOptions.postForm(formData)
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}
function importCarLoanSetting(file, companyId) {
  let formData = new FormData();
  formData.append("File", file);
  formData.append("CompanyId", companyId);
  return fetch(
    `${config.apiurl}/organization/importCarLoanSetting`,
    requestOptions.postForm(formData)
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}
function importDepartmentUnit(file) {
  let formData = new FormData();
  formData.append("File", file);
  return fetch(
    `${config.apiurl}/organization/importDepartmentUnit`,
    requestOptions.postForm(formData)
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}
function getPensions() {
  return fetch(
    `${config.apiurl}/Miscellaneous/getLookup?type=PFMANAGERS`,
    requestOptions.get()
  )
    .then(handleResponse)
    .then(model => {
      return model;
    });
}

function updateDesignation(id, departmentId, name) {
  var req = {
    id,
    departmentId,
    name
  };
  return fetch(
    `${config.apiurl}/Miscellaneous/updateDesignation`,
    requestOptions.put(req)
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}

function removeDesignation(id) {
  return fetch(
    `${config.apiurl}/Miscellaneous/deleteDesignation?id=${id}`,
    requestOptions.delete()
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}

function removeDepartmentPolicy(id) {
  return fetch(
    `${config.apiurl}/Miscellaneous/deletePolicy?id=${id}`,
    requestOptions.delete()
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}

function addDepartment(name, glCode) {
  var req = {
    name,
    glCode
  };
  return fetch(
    `${config.apiurl}/Miscellaneous/createDepartment`,
    requestOptions.post(req)
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}

function getDepartments() {
  return fetch(
    `${config.apiurl}/Miscellaneous/getDepartments`,
    requestOptions.get()
  )
    .then(handleResponse)
    .then(model => {
      return model;
    });
}

function updateDepartment(id, name, glCode) {
  var req = {
    id,
    name,
    glCode
  };
  return fetch(
    `${config.apiurl}/Miscellaneous/updateDepartment`,
    requestOptions.put(req)
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}
function updateDepartmentByGMD(id, status) {
  return fetch(
    `${config.apiurl}/Miscellaneous/updateDepartment`,
    requestOptions.put(status)
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}
function updateDesignationByGMD(id, status) {
  return fetch(
    `${config.apiurl}/Miscellaneous/updateDesignation`,
    requestOptions.put(status)
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}

function removeDepartment(id) {
  return fetch(
    `${config.apiurl}/Miscellaneous/deleteDepartment?id=${id}`,
    requestOptions.delete()
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}

function updateCompany(id, name, abbrv, address, contactPerson, phone, email) {
  var req = {
    name,
    abbrv,
    address,
    contactPerson,
    phone,
    email
  };
  return fetch(`${config.apiurl}/company?id=${id}`, requestOptions.put(req))
    .then(handleResponse)
    .then(id => {
      return id;
    });
}

function updateLeaveSettings(leavesettings) {
  return fetch(
    `${config.apiurl}/company/putleavesetting?id=${leavesettings.id}`,
    requestOptions.put(leavesettings)
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}

function updateAccountSetting(
  id,
  companyId,
  bankAccountForSalary,
  bankCodeForSalary,
  bankAccountForPension,
  bankCodeForPension,
  bankAccountForTax,
  bankCodeForTax,
  employerCodeForPension,
  remitaUserAccount,
  remitaSecret,
  salaryPayDay,
  welcomeGuideTemplate,
  profileNOK,
  profileGLI,
  automateTaxPension,
  mgtDesignationId
) {
  var req = {
    companyId: companyId,
    bankAccountForSalary,
    bankCodeForSalary,
    bankAccountForPension,
    bankCodeForPension,
    bankAccountForTax,
    bankCodeForTax,
    employerCodeForPension,
    remitaUserAccount,
    remitaSecret,
    salaryPayDay,
    welcomeGuideTemplate,
    profileNOK,
    profileGLI,
    automateTaxPension,
    mgtDesignationId
  };
  return fetch(
    `${config.apiurl}/company/putaccount?id=${id}`,
    requestOptions.put(req)
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}

function removeCompany(id) {
  return fetch(
    `${config.apiurl}/company/Inactive?Id=${id}`,
    requestOptions.put()
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}

function getCompanies() {
  return fetch(`${config.apiurl}/company`, requestOptions.get())
    .then(handleResponse)
    .then(model => {
      return model;
    });
}

function getCompany(id) {
  return fetch(`${config.apiurl}/company/${id}`, requestOptions.get())
    .then(handleResponse)
    .then(model => {
      return model;
    });
}

// #region Company Unit
function addCompanyUnit(companyId, name) {
  var req = {
    companyId,
    name
  };
  return fetch(`${config.apiurl}/Company/CompanyUnit`, requestOptions.post(req))
    .then(handleResponse)
    .then(id => {
      return id;
    });
}

function getCompanyUnits(id) {
  return fetch(
    `${config.apiurl}/Company/CompanyUnitsByCompanyId?id=${id}`,
    requestOptions.get()
  )
    .then(handleResponse)
    .then(model => {
      return model;
    });
}

function updateCompanyUnit(id, name) {
  var req = {
    id,
    name
  };
  return fetch(
    `${config.apiurl}/Company/CompanyUnit?id=${id}`,
    requestOptions.put(req)
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}

function updateCompanyUnitsByGMD(id, status) {
  return fetch(
    `${config.apiurl}/Company/CompanyUnit?id=${id}`,
    requestOptions.put(status)
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}

function removeCompanyUnit(id) {
  return fetch(
    `${config.apiurl}/Company/CompanyUnit?id=${id}`,
    requestOptions.delete()
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}
// #endregion

// #region Department Unit
function addDepartmentUnit(name, departmentId) {
  var req = {
    name,
    departmentId
  };
  return fetch(
    `${config.apiurl}/Designation/PostDepartmentUnit`,
    requestOptions.post(req)
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}

function getDepartmentUnits() {
  return fetch(
    `${config.apiurl}/Designation/GetDepartmentUnits`,
    requestOptions.get()
  )
    .then(handleResponse)
    .then(model => {
      return model;
    });
}

function updateDepartmentUnit(req) {
  return fetch(
    `${config.apiurl}/Designation/PutDepartmentUnit?Id=${req.id}`,
    requestOptions.put(req)
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}

function removeDepartmentUnit(id) {
  return fetch(
    `${config.apiurl}/Designation/DeleteDepartmentUnit?id=${id}`,
    requestOptions.delete()
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}
// #endregion

// #region Designation Roles
function addDesignationRole(designationId, roleId) {
  var req = {
    designationId,
    roleId
  };
  return fetch(
    `${config.apiurl}/Designation/PostDesginationRole`,
    requestOptions.post(req)
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}

function getDesignationRoles() {
  return fetch(
    `${config.apiurl}/Designation/GetDesginationRoles`,
    requestOptions.get()
  )
    .then(handleResponse)
    .then(model => {
      return model;
    });
}
function getRoles() {
  return fetch(`${config.apiurl}/Account/iRoles`, requestOptions.get())
    .then(handleResponse)
    .then(model => {
      return model;
    });
}

function updateDesignationRole(req) {
  return fetch(
    `${config.apiurl}/Designation/PutDesignationRole?Id=${req.id}`,
    requestOptions.put(req)
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}

function removeDesignationRole(id) {
  return fetch(
    `${config.apiurl}/Designation/DeleteDesignationRole?id=${id}`,
    requestOptions.delete()
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}
// #endregion



// WEBPACK FOOTER //
// ./src/services/organizationService.js